var _rect, _rect2, _circle, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _circle2, _circle3, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdminDashboardShowcase(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1600,
    height: 900,
    viewBox: "0 0 1600 900",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 900,
    rx: 30,
    fill: "#EDEFFE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 280,
    height: 900,
    fill: "url(#paint0_linear)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 34,
    r: 18,
    fill: "#F8FAFC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 19,
    width: 110,
    height: 10,
    rx: 5,
    fill: "#F8FAFC",
    fillOpacity: 0.9
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 34,
    width: 140,
    height: 14,
    rx: 7,
    fill: "#F8FAFC"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 58,
    width: 100,
    height: 24,
    rx: 12,
    fill: "#16375F"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 740,
    width: 280,
    height: 160,
    fill: "#172238"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 141,
    width: 250,
    height: 44,
    rx: 16,
    fill: "url(#paint1_linear)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 148,
    width: 18,
    height: 18,
    rx: 4,
    fill: "#F8FAFC"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 151,
    width: 128,
    height: 12,
    rx: 6,
    fill: "#F8FAFC"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 198,
    width: 12,
    height: 12,
    rx: 6,
    fill: "#F8FAFC",
    fillOpacity: 0.75
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 197,
    width: 88,
    height: 12,
    rx: 6,
    fill: "#F8FAFC"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 24,
    width: 70,
    height: 8,
    rx: 4,
    fill: "#4F46E5"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 418,
    y: 24,
    width: 154,
    height: 8,
    rx: 4,
    fill: "#7C8499"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 610,
    y: 24,
    width: 78,
    height: 8,
    rx: 4,
    fill: "#7C8499"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 716,
    y: 24,
    width: 94,
    height: 8,
    rx: 4,
    fill: "#7C8499"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 840,
    y: 24,
    width: 132,
    height: 8,
    rx: 4,
    fill: "#7C8499"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 1000,
    y: 20,
    width: 132,
    height: 22,
    rx: 10,
    fill: "#E4E7FB"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 1158,
    y: 24,
    width: 64,
    height: 8,
    rx: 4,
    fill: "#7C8499"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1508,
    cy: 30,
    r: 18,
    fill: "#E4E7FB"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1548,
    cy: 30,
    r: 18,
    fill: "#D8DBEA"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 82,
    width: 264,
    height: 16,
    rx: 8,
    fill: "#20263B"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 112,
    width: 250,
    height: 10,
    rx: 5,
    fill: "#667085"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 1384,
    y: 98,
    width: 104,
    height: 10,
    rx: 5,
    fill: "#667085"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 1508,
    y: 84,
    width: 40,
    height: 40,
    rx: 10,
    fill: "#FFFFFF"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 170,
    width: 96,
    height: 72,
    rx: 18,
    fill: "#EEF0FF",
    stroke: "#D5DBFF"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 418,
    y: 170,
    width: 96,
    height: 72,
    rx: 18,
    fill: "#E8F3FF",
    stroke: "#CCE4FF"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 530,
    y: 170,
    width: 96,
    height: 72,
    rx: 18,
    fill: "#EEF9F4",
    stroke: "#D6F2E5"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 642,
    y: 170,
    width: 96,
    height: 72,
    rx: 18,
    fill: "#FFF1E8",
    stroke: "#FFDCC7"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 754,
    y: 170,
    width: 96,
    height: 72,
    rx: 18,
    fill: "#F0EEFF",
    stroke: "#D9D4FF"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 866,
    y: 170,
    width: 96,
    height: 72,
    rx: 18,
    fill: "#E8F6FF",
    stroke: "#CDEAFF"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 978,
    y: 170,
    width: 96,
    height: 72,
    rx: 18,
    fill: "#EDF8F6",
    stroke: "#D5EEE8"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 1090,
    y: 170,
    width: 96,
    height: 72,
    rx: 18,
    fill: "#FFF0F4",
    stroke: "#FFD5E2"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 1202,
    y: 170,
    width: 96,
    height: 72,
    rx: 18,
    fill: "#F1EEFF",
    stroke: "#DFD8FF"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 1314,
    y: 170,
    width: 96,
    height: 72,
    rx: 18,
    fill: "#FFF3E8",
    stroke: "#FFE0C4"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 1426,
    y: 170,
    width: 96,
    height: 72,
    rx: 18,
    fill: "#EEF4F8",
    stroke: "#D5DEE6"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 316,
    width: 360,
    height: 230,
    rx: 24,
    fill: "url(#paint2_linear)"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 704,
    y: 316,
    width: 838,
    height: 230,
    rx: 24,
    fill: "#FFFFFF",
    stroke: "#DDE6EA"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 734,
    y: 346,
    width: 290,
    height: 18,
    rx: 9,
    fill: "#20263B"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 734,
    y: 378,
    width: 210,
    height: 10,
    rx: 5,
    fill: "#667085"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 1462,
    y: 342,
    width: 56,
    height: 24,
    rx: 12,
    fill: "#EEF7F2"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 751,
    y: 432,
    width: 176,
    height: 70,
    rx: 16,
    fill: "#F6FAFD",
    stroke: "#DCE8EE"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 944,
    y: 432,
    width: 176,
    height: 70,
    rx: 16,
    fill: "#F5FBF7",
    stroke: "#DBEEE3"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 1137,
    y: 432,
    width: 176,
    height: 70,
    rx: 16,
    fill: "#FFF9F4",
    stroke: "#F4E2D8"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 751,
    y: 518,
    width: 176,
    height: 70,
    rx: 16,
    fill: "#FFF8F8",
    stroke: "#F6DDE0"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 944,
    y: 518,
    width: 369,
    height: 70,
    rx: 16,
    fill: "#FFF8F8",
    stroke: "#F6DDE0"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 1348,
    y: 518,
    width: 176,
    height: 70,
    rx: 16,
    stroke: "#D7DCE5",
    strokeDasharray: "6 6"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 598,
    width: 52,
    height: 52,
    rx: 26,
    fill: "#E5E8F4"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 372,
    y: 612,
    width: 212,
    height: 18,
    rx: 9,
    fill: "#20263B"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 372,
    y: 646,
    width: 324,
    height: 10,
    rx: 5,
    fill: "#667085"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 690,
    width: 828,
    height: 170,
    rx: 24,
    fill: "#FFFFFF",
    stroke: "#DCE5EA"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 1156,
    y: 690,
    width: 386,
    height: 170,
    rx: 24,
    fill: "#FFFFFF",
    stroke: "#DCE5EA"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 742,
    width: 720,
    height: 1,
    fill: "#E9EDF2"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 784,
    width: 720,
    height: 1,
    fill: "#E9EDF2"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 826,
    width: 720,
    height: 1,
    fill: "#E9EDF2"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 1190,
    y: 726,
    width: 170,
    height: 18,
    rx: 9,
    fill: "#20263B"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 1190,
    y: 820,
    width: 300,
    height: 14,
    rx: 7,
    fill: "#E4E7FB"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 772,
    width: 72,
    height: 10,
    rx: 5,
    fill: "#AEB6CC"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 814,
    width: 14,
    height: 14,
    rx: 7,
    fill: "#AEB6CC"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 814,
    width: 84,
    height: 12,
    rx: 6,
    fill: "#F8FAFC"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 862,
    width: 14,
    height: 14,
    rx: 7,
    fill: "#AEB6CC"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 862,
    width: 68,
    height: 12,
    rx: 6,
    fill: "#F8FAFC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 0,
    y1: 0,
    x2: 280,
    y2: 900,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#131A2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10192C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 16,
    y1: 141,
    x2: 266,
    y2: 185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#323E8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B4D74"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 306,
    y1: 316,
    x2: 666,
    y2: 546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4AE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A2FF0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminDashboardShowcase);
export default __webpack_public_path__ + "static/media/admin-dashboard-showcase.824cbd12ac899c71bf3b2a51b3e254d5.svg";
export { ForwardRef as ReactComponent };